import React from 'react';

export default function Tank2Icon({
  width = 64,
  height = 62,
  startColor = '#1E1E1E',
  midColor = '#EBEBEB',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 108.9" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="6.9751" y1="1.6873" x2="105.5254" y2="1.6873">
	<stop offset="0" style={{stopColor: "#373737"}} />
	<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
	<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
	<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
	<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
	<stop offset="1" style={{stopColor: "#373737"}} />
</linearGradient>
<path fill={`url(#${id}_1_)`} d="M6.975,3.375h98.55L56.25,0L6.975,3.375" />
<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="0" y1="56.1375" x2="112.5" y2="56.1375">
	<stop offset="0" style={{stopColor: "#373737"}} />
	<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
	<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
	<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
	<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
	<stop offset="1" style={{stopColor: "#373737"}} />
</linearGradient>
<path fill={`url(#${id}_2_)`} d="M0,101.925l6.975,6.976h98.55l6.975-6.976v-91.35l-6.975-7.2H6.975L0,10.575V101.925" />
<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="0.1196" y1="6.9128" x2="112.3799" y2="6.9128">
	<stop offset="0" style={{stopColor: "#1E1E1E"}} />
	<stop offset="0.45" style={{stopColor: "#989898"}} />
	<stop offset="0.62" style={{stopColor: "#858585"}} />
	<stop offset="0.77" style={{stopColor: "#727272"}} />
	<stop offset="1" style={{stopColor: "#1E1E1E"}} />
</linearGradient>
<polygon fill={`url(#${id}_3_)`} points="112.38,10.451 105.525,3.375 6.975,3.375 0.12,10.451 " />
<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="0.0264" y1="105.4255" x2="112.4736" y2="105.4255">
	<stop offset="0" style={{stopColor: "#1E1E1E"}} />
	<stop offset="0.45" style={{stopColor: "#989898"}} />
	<stop offset="0.62" style={{stopColor: "#858585"}} />
	<stop offset="0.77" style={{stopColor: "#727272"}} />
	<stop offset="1" style={{stopColor: "#1E1E1E"}} />
</linearGradient>
<polygon fill={`url(#${id}_4_)`} points="0.026,101.951 6.975,108.9 105.525,108.9 112.474,101.951 " />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="108.9" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
